import { useMemo } from 'react';

const useRows = (
  sortedAndFilteredResults: Array<any>,
  onDownloadClick: (id: string) => void,
) => {
  return useMemo(
    () =>
      sortedAndFilteredResults.map((row) => {
        return {
          id: row.id,
          source: {
            value: row.source,
          },
          date: {
            value: row.createdAt,
            variant: 'dateTime',
          },
          download: {
            variant: 'iconButton',
            onClick: () => onDownloadClick(row.id),
            iconName: 'DownloadIcon',
          },
        };
      }),
    [sortedAndFilteredResults],
  );
};

export default useRows;
